import { render, staticRenderFns } from "./remote-attendance-log-checkbox.vue?vue&type=template&id=009601ef&"
import script from "./remote-attendance-log-checkbox.vue?vue&type=script&lang=js&"
export * from "./remote-attendance-log-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports